// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"b4c18bd6","41":"c972caf1","93":"c972caf1","154":"01e72450","172":"27b81052","206":"9353103c","419":"2a1f1833","466":"a34ecb3d","486":"13f3d19a","533":"1e594597","551":"baebc481","644":"252a2e20","754":"c972caf1","771":"379b47b7","780":"d0edc5e8","953":"1a91a559"}[chunkId] + ".chunk.css";
};